import React from 'react';
import { HINWEISKASTEN, KNOPF_PRIMAER } from '../../sifa/public/teilnahmeSeiteStil';
import { formatZeitpunkt, type FreimeldungTexte, type Sprache } from './freimeldungLogic';
import type { FreimeldungAbschluss } from './useFreimeldung';

/**
 * Quittung nach der Meldung. Bei `bereits` (dieselbe Firma und Person hatten
 * den Mangel schon gemeldet) legt die RPC kein Doppel an — die Seite sagt das,
 * statt einen zweiten Erfolg vorzutaeuschen.
 *
 * Der Mangel ist damit NICHT geschlossen: darueber entscheidet der
 * Koordinator. Genau das steht im Hinweiskasten.
 */
export const FreimeldungErgebnis: React.FC<{
  ergebnis: FreimeldungAbschluss;
  texte: FreimeldungTexte;
  sprache: Sprache;
  onWeiterenMelden: () => void;
}> = ({ ergebnis, texte, sprache, onWeiterenMelden }) => {
  const zeitpunkt = formatZeitpunkt(ergebnis.gemeldetAt, sprache);
  const nummer = ergebnis.nummer == null ? '' : `#${ergebnis.nummer}`;
  const zurueck = ergebnis.art === 'zurueckgewiesen';

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <span
          aria-hidden="true"
          className="flex items-center justify-center w-12 h-12 rounded-full bg-emerald-100 text-emerald-700 shrink-0"
        >
          <svg viewBox="0 0 24 24" className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 13l4 4L19 7" />
          </svg>
        </span>
        <h2 className="text-2xl font-bold text-emerald-700">
          {ergebnis.bereits ? texte.bereitsTitel : zurueck ? texte.erfolgTitelZurueck : texte.erfolgTitel}
        </h2>
      </div>

      <p className="text-slate-700" aria-live="polite">
        {ergebnis.bereits ? texte.bereitsText : zurueck ? texte.erfolgTextZurueck : texte.erfolgText}
      </p>

      {(nummer || ergebnis.titel) && (
        <div className="p-3 bg-slate-50 border border-slate-200 rounded-xl space-y-1">
          <div className="flex flex-wrap items-center gap-2">
            {nummer && <span className="px-2 py-0.5 rounded-lg bg-slate-800 text-white text-sm font-bold">{nummer}</span>}
            {zeitpunkt && (
              <span className="text-sm text-slate-500">
                {texte.gemeldetAm} {zeitpunkt}
              </span>
            )}
          </div>
          {ergebnis.titel && <p className="font-semibold text-slate-900 break-words">{ergebnis.titel}</p>}
        </div>
      )}

      <div className={HINWEISKASTEN}>
        {texte.hinweisPruefung} {texte.fensterSchliessen}
      </div>

      <button type="button" onClick={onWeiterenMelden} className={KNOPF_PRIMAER}>
        {texte.weiterenMelden}
      </button>
    </div>
  );
};
